document.cookie = 'post-protection=1; expires=' + (new Date(new Date().getTime() + (86400 * 7 * 1000))).toGMTString() + '; path=/; secure; samesite=none';

$(document).ready(function(){
	// https://owlcarousel2.github.io/OwlCarousel2/index.html
	$('.owl-carousel').owlCarousel({
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		items: 1
	});

	$('#menu-control').click(function() {
		$(this).parents('header').toggleClass('active');

		return false;
	});

	$('#menu a').click(function() {
		$(this).parents('header').removeClass('active');
	});
});
